import { setAttr } from 'redom';

export function decorateWithShowHide(cls) {

  cls.prototype.show = function show() {

    setAttr(this.el, {
      style: {
        display: this.displayMode || 'block'
      }
    });

  };

  cls.prototype.hide = function hide() {

    setAttr(this.el, {
      style: {
        display: 'none'
      }
    });

  };

  return cls;

}